export const dropDownItems = {
  content: ['Product1', 'Product2', 'Product3', 'Product4', 'Product5', 'Product6', 'Product7'],
  title: 'Title Content',
};

export const dropDownItems2 = {
  title: 'Title Content 2',
  content: [
    'Product1Set2',
    'Product2Set2',
    'Product3Set2',
    'Product4Set2',
    'Product5Set2',
    'Product6Set2',
    'Product7Set2',
  ],
};

export const dropDownItems3 = {
  title: 'Title Content 3',
  content: [
    'Product1Set3',
    'Product2Set3',
    'Product3Set3',
    'Product4Set3',
    'Product5Set3',
    'Product6Set3',
    'Product7Set3',
  ],
};

export const columnContent = [dropDownItems, dropDownItems2, dropDownItems3];

export const ariaLabelForIcon = 'Menu';
export const ariaLabelForFavorites = 'Favorites';
export const ariaLabelForCart = 'Cart';
export const ariaLabelForProfileIcon = 'Profile';
export const userItems = ['New & Featured ', 'Men', 'Women', 'Kids', 'Accessories'];
export const resetSearchLabel = 'reset search';
export const searchLabel = 'Search';
export const searchLabelOpen = 'searchLabelOpen';
export const cancelSearchLabel = 'cancelSearchLabel';
export const searchInputLabel = 'searchInputLabel';

const type = 'click_navShoppingMenu';
const path = 'shoppingItem';

export const mockClickEventPayload = {
  props: {
    path,
  },
  type,
};

export const userMenuItems = [
  { msg: 'Find a store' },
  { hasDropDown: true, msg: 'Help' },
  { msg: 'Join us' },
  { hasDropDown: true, isLogin: true, msg: 'Hi, Global Nav User!' },
];
